// Styles
import { concatStyleSets, memoizeFunction, mergeStyles } from "@fluentui/react";
import { screenReaderOnly } from "../../utilities/Mixin.styles";
/**
 * Helper to get styles for ScreenReaderOnly control
 * @param customStyles Any custom style overrides
 */ export const getStyles = memoizeFunction((customStyles)=>{
    const root = [
        screenReaderOnly,
        {
            width: "auto"
        }
    ];
    const styles = {
        root
    };
    return concatStyleSets(styles, customStyles);
});
/**
 * Get the classnames associated with the computed styles
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>({
        root: mergeStyles("screen-reader-only", styles.root)
    }));
